<app-topnav></app-topnav>
<app-video-tile></app-video-tile>
<!-- <section id="hero" class="d-flex align-items-center">

  <div class="container">
    <div class="row align-items-center">
      <div class="col-12">
        <div class="row justify-content-center">
          <div class="col-md-7 text-center hero-text">
            <h1 data-aos="fade-up" data-aos-delay="">Being an Agent</h1>
            <p class="mb-5" data-aos="fade-up" style="color: white;"  data-aos-delay="100">Fill the below form for Getting Approval from Administration</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</section> -->
<main id="main">

<section class="section">

  <div class="container boxframe">

    <h1 data-aos="fade-up" data-aos-delay="">Being an Agent</h1>
    <p class="mb-5" data-aos="fade-up" style="color: white;"  data-aos-delay="100">Fill the below form for Getting Approval from Administration</p>

    <div class="col-md-12 mb-5 mb-md-0" data-aos="fade-up">
      <!-- <form action="forms/contact.php" method="post" role="form" class="php-email-form"> -->

        <div class="row">
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Name<span style="color: red;">*</span></label> -->
            <input type="text" name="name" placeholder="Name*" class="form-control" [(ngModel)]="forBusiness.name" id="name"  required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Email<span style="color: red;">*</span></label> -->
            <input type="email" placeholder="Email*" #email class="form-control" [(ngModel)]="forBusiness.email" name="email" id="email" required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Phone No<span style="color: red;">*</span></label> -->
            <input type="text" placeholder="Phone No*" name="phoneno" class="form-control" [(ngModel)]="forBusiness.phoneno" id="phoneno"  required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Alternative No</label> -->
            <input type="text" placeholder="Alternative No" class="form-control" name="altno" [(ngModel)]="forBusiness.alternativeno" id="altno" required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Aadhar No<span style="color: red;">*</span></label> -->
            <input type="text" placeholder="Aadhar No*" name="aadharno" class="form-control" [(ngModel)]="forBusiness.aadharno" id="aadharno"  required>
          </div>
          <div class="col-md-12 form-group mt-3">
            <!-- <label for="name">Address<span style="color: red;">*</span></label> -->
            <textarea class="form-control" placeholder="Address*" name="address" [(ngModel)]="forBusiness.address" required></textarea>
          </div>


          <div class="col-md-12 mb-3">
            <div class="sent-message" style="color: red;">{{error}}</div>
            <div class="sent-message" style="color: green;">{{success}}</div>
          </div>
          <div class="col-md-6 form-group">&nbsp;
          </div>
          <div class="col-md-6 form-group">
            <input type="submit" (click)="onBusinessRequestSubmit()" class="btn btn-primary d-block w-100" value="Send Request">
          </div>
        </div>

      <!-- </form> -->
    </div>


  </div>

</section>

</main>
